import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiEnvelope, CreatePasswordBody } from './api-envelope.model';

/**
 * Admin auth & user profile HTTP API. Returns backend envelopes as-is.
 * Map/normalize in components or a dedicated mapper, not here.
 */
@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiBaseUrl.replace(/\/$/, '');

  adminLogin(body: { email_id: string; password: string }): Observable<ApiEnvelope<unknown>> {
    return this.http.post<ApiEnvelope<unknown>>(`${this.base}/auth/admin/login`, body);
  }

  verifyAdminMfa(email_id: string, otp: string): Observable<ApiEnvelope<unknown>> {
    return this.http.post<ApiEnvelope<unknown>>(`${this.base}/auth/admin/verify-mfa`, { email_id, otp });
  }

  adminLogout(): Observable<ApiEnvelope<unknown>> {
    return this.http.post<ApiEnvelope<unknown>>(`${this.base}/auth/admin/logout`, {});
  }

  /** Admin portal: `PATCH /auth/admin/forgot-password`. */
  forgotPassword(email_id: string): Observable<ApiEnvelope<unknown>> {
    return this.http.patch<ApiEnvelope<unknown>>(`${this.base}/auth/admin/forgot-password`, {
      email_id,
    });
  }

  getPasswordToken(token: string): Observable<ApiEnvelope<Record<string, unknown>>> {
    // Encode the token in the URL ourselves: Angular's HttpParams codec leaves `/`, `$`, `+`
    // unencoded, so a bcrypt token's `/` gets mangled by the server's reverse proxy (works on a
    // direct local connection, 409s on the server). encodeURIComponent keeps it intact.
    return this.http.get<ApiEnvelope<Record<string, unknown>>>(
      `${this.base}/auth/password-token?token=${encodeURIComponent(token)}`,
    );
  }

  createPassword(body: CreatePasswordBody): Observable<ApiEnvelope<unknown>> {
    return this.http.patch<ApiEnvelope<unknown>>(`${this.base}/auth/admin/create-password`, body);
  }

  getUserProfile(): Observable<ApiEnvelope<unknown>> {
    return this.http.get<ApiEnvelope<unknown>>(`${this.base}/user/profile`);
  }
}
